/**
 * Zerops Services - Shared Scripts Templates
 *
 * Common shell scripts and command arrays used in YAML generation
 * for both zagent and zcde services.
 *
 * Note: With zcp@1 base, most tools are pre-installed:
 * - sshfs, jq, tree, ripgrep, fd-find, httpie, gh, make, bat, ncdu, htop, tmux, fzf
 * - postgresql-client, mariadb-client, redis-tools
 * - google-chrome-stable + puppeteer dependencies
 * - code-server with vscode-terminals and claude-code extensions
 * - claude-code CLI, opencode-ai, gemini-cli, codex
 * - zsh + oh-my-zsh
 * - yq
 *
 * Container setup (SSH config, git config, Claude configs, VS Code settings,
 * SSHFS mounts, nginx proxy) is now handled by zcp subcommands:
 * - zcp init          — SSH config, git config, Claude configs, VS Code settings (if ZCP_VSCODE=true)
 * - zcp init sshfs    — SSHFS mounts from ZCP_SSHFS_HOSTNAMES env
 * - sudo -E zcp init nginx — nginx proxy config with optional cookie-based auth (via VSCODE_PASSWORD)
 * - zcp service start nginx  — starts nginx
 * - zcp service start vscode — starts code-server
 */

/**
 * zcp install command - optionally pinned to a specific version (e.g. 'v0.1.0')
 */
export const zcpInstallCommand = (version?: string): string => {
  const versionArg = version ? ` -s ${version}` : '';
  return `curl -sSfL https://zerops.io/zcp/install.sh | sudo sh${versionArg}`;
};

/**
 * Provider to environment variable mapping
 */
export const PROVIDER_ENV_VAR_MAP: Record<string, string> = {
  'anthropic': 'ANTHROPIC_API_KEY',
  'openai': 'OPENAI_API_KEY',
  'azure-openai': 'AZURE_OPENAI_API_KEY',
  'groq': 'GROQ_API_KEY',
  'together': 'TOGETHER_API_KEY',
  'fireworks': 'FIREWORKS_API_KEY',
  'deepseek': 'DEEPSEEK_API_KEY',
  'cerebras': 'CEREBRAS_API_KEY',
  'moonshot': 'MOONSHOT_API_KEY',
  'zhipu': 'ZHIPU_API_KEY',
  'openrouter': 'OPENROUTER_API_KEY',
  'xai': 'XAI_API_KEY',
  'google': 'GEMINI_API_KEY',
  'cursor': 'CURSOR_API_KEY'
};
